export const donateDeepColor = "#f16e40";
export const shareColor = "#ffa44e";
